import { BaleTypeEnum, QualityTypeEnum } from "@gtpl/shared-models/common-models"

export class BaleReq{
    date : any;
    type : BaleTypeEnum;
    totQty : number;
    baleItemsInfo : BaleItemReq[];
    createdUser : string;
    plantId : number;
    actualBaleQty : number;
    variantId : number;
    quality : QualityTypeEnum;
    tareWeight : number;
    grossQty : number
    baleId?:number
    constructor(date : any,type : BaleTypeEnum,baleItemsInfo : BaleItemReq[],totQty : number,createdUser : string,plantId : number,actualBaleQty : number,variantId : number,quality : QualityTypeEnum,tareWeight : number,grossQty : number,baleId?:number){
        this.date = date
        this.type = type
        this.totQty = totQty
        this.baleItemsInfo = baleItemsInfo
        this.createdUser = createdUser
        this.plantId = plantId
        this.actualBaleQty = actualBaleQty
        this.variantId = variantId
        this.quality = quality
        this.tareWeight = tareWeight
        this.grossQty = grossQty
        this.baleId = baleId
    }
    
}

export class BaleItemReq{
    agentId : number;
    quality : QualityTypeEnum;
    baleQty : number;
    voucherno : string;
    inwardItemId : number;
    variantId : number;
    reportingType : string;
    inwardPrice : number;
    

    constructor(agentId : number,quality : QualityTypeEnum,baleQty : number,voucherno : string,inwardItemId : number,variantId : number,reportingType : string,inwardPrice : number){
        this.agentId = agentId
        this.quality = quality
        this.baleQty = baleQty
        this.voucherno = voucherno
        this.inwardItemId = inwardItemId
        this.variantId = variantId
        this.reportingType = reportingType
        this.inwardPrice = inwardPrice
    }
}

export class BaleQtyUpdateReq {
  baleId: number;
  baleNumber: string;
  actualBaleQty: number;
  date:Date

  constructor(baleId: number, baleNumber: string, actualBaleQty: number,date:Date) {
    this.baleId = baleId;
    this.baleNumber = baleNumber;
    this.actualBaleQty = actualBaleQty;
    this.date = date;
  }
}